import apiStateReducer from './apiStateSlice';
import { authReducer } from './authSlice';
import { projectReducer } from './projectSlice';
import { releaseReducer } from './releaseSlice';

export const slices = {
  auth: authReducer,
  project: projectReducer,
  release: releaseReducer,
  apiState: apiStateReducer,
};

export type SliceType = (typeof slices)[keyof typeof slices];

export * from './apiStateSlice';
export * from './authSlice';
export * from './projectSlice';
export * from './releaseSlice';
